/**
 * Picks the DOM node where a global loading overlay should be portaled when the
 * note editor overlay is active. Keeps modal loaders visible above trapped stacking
 * contexts, and lifts loaders inside the note overlay anchor above in-overlay modals.
 */
export function resolveLoadingPortalTarget(
  container: HTMLElement | null | undefined,
): HTMLElement {
  const anchor = container ?? document.body
  const overlayActive = document.body.classList.contains(
    'note-editor-overlay-active',
  )
  const isContainerInModal = Boolean(anchor.closest('.modal'))
  const isContainerInNoteOverlay = Boolean(
    anchor.closest('.note-editor-overlay-anchor'),
  )

  const escapeNoteOverlayStack =
    overlayActive && isContainerInNoteOverlay && container !== document.body

  if (overlayActive && isContainerInModal && !isContainerInNoteOverlay) {
    return document.body
  }
  if (escapeNoteOverlayStack) {
    return document.body
  }
  return anchor
}
